/**
 * Video constants matching Flutter app configuration
 */
export const VIDEO_CONSTANTS = {
  // Streaming manifest files (matching Flutter AppConstants)
  // Web uses HLS (.m3u8) for better browser support
  MASTER_HLS_NAME: 'master.m3u8',           // Full quality HLS
  MASTER_LIGHT_HLS_NAME: 'master_light.m3u8', // Light quality HLS
  MASTER_DASH_NAME: 'manifest.mpd',         // Full quality DASH (not used on web)
  MASTER_LIGHT_DASH_NAME: 'manifest_light.mpd', // Light quality DASH (not used on web)
  DEFAULT_ASPECT_RATIO: 9 / 16, // Default aspect ratio for videos (used when metadata is unavailable)
} as const;

export type VideoConstants = typeof VIDEO_CONSTANTS;

/**
 * Secret-Manager key-name prefixes for the per-video AES key + IV, split by
 * pipeline. These MUST byte-match the `cloud_functions` `.env` prefixes the
 * encryption pipeline shifts each key with, because the client unshift mask is
 * `sha256(`${prefix}${id}`)` — a mismatch produces a garbage key and decryption
 * fails with an `OperationError`.
 *
 * - `userGen`   ⇄ `EXPAUSE_MEDIA_CDN_VIDEO_SECRET_KEY_PREFIX` /
 *   `EXPAUSE_MEDIA_CDN_IV_SECRET_KEY_PREFIX`
 * - `chat`      ⇄ `EXPAUSE_CHAT_MEDIA_CDN_VIDEO_SECRET_KEY_PREFIX` /
 *   `EXPAUSE_CHAT_MEDIA_CDN_IV_SECRET_KEY_PREFIX`
 * - `community` ⇄ `EXPAUSE_COMMUNITY_MEDIA_CDN_VIDEO_SECRET_KEY_PREFIX` /
 *   `EXPAUSE_COMMUNITY_MEDIA_CDN_IV_SECRET_KEY_PREFIX`
 */
export const VIDEO_SECRET_KEY_PREFIXES = {
  userGen: {
    encryptionKeyPrefix: 'expause-video-key-',
    ivKeyPrefix: 'expause-iv-key-',
  },
  chat: {
    encryptionKeyPrefix: 'expause-chat-video-key-',
    ivKeyPrefix: 'expause-chat-iv-key-',
  },
  community: {
    encryptionKeyPrefix: 'expause-community-video-key-',
    ivKeyPrefix: 'expause-community-iv-key-',
  },
} as const;
